<template>
  <div class=" bulletion-container" :style="{ height: scrollHeight + 'px' }">
    <div class="panel flex flex-end item-center">
      <el-select
        size="small"
        class="mr10"
        clearable
        v-model="searchConditions.loopType"
        placeholder="请选择考核周期"
      >
        <el-option label="年" value="year"></el-option>
        <el-option label="月" value="month"></el-option>
        <el-option label="日" value="date"></el-option>
      </el-select>
      <el-input
        class="mr10"
        v-model="searchConditions.taskName"
        placeholder="请输入考核名称"
        clearable
        size="small"
      ></el-input>
      <el-button size="small" type="primary" @click="search">查询</el-button>
    </div>
    <div class="flex">
      <template v-for="(v, i) in bulletinBoardList">
        <component
          ref="HmBulletinBoard"
          :key="i"
          :is="v.componentName"
          v-bind="v"
        ></component>
      </template>
    </div>
  </div>
</template>

<script>
import HmBulletinBoard from "@/components/HmBulletinBoard";
export default {
  components: {
    HmBulletinBoard
  },
  data() {
    return {
      bulletinBoardList: [
        {
          componentName: "HmBulletinBoard",
          scrollHeight: 0,
          statusText: "进行中",
          action: "queryTargetTaskList",
          confirmStatus: "inProgress",
          searchConditions: {},
          color: "#999999"
        },
        {
          componentName: "HmBulletinBoard",
          scrollHeight: 0,
          statusText: "待评分",
          action: "queryTargetTaskList",
          confirmStatus: "toConfirmed",
          searchConditions: {},
          color: "#0081E5"
        },
        {
          componentName: "HmBulletinBoard",
          scrollHeight: 0,
          statusText: "已评分",
          action: "queryTargetTaskList",
          confirmStatus: "confirmed",
          searchConditions: {},
          color: "#2FC348"
        }
      ],
      searchConditions: {
        loopType: "",
        taskName: ""
      },
      scrollHeight: ""
    };
  },
  created() {},
  mounted() {
    this.calcMainEleHeight();
    window.addEventListener("resize", this.handleResize, true);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    search() {
      const refsList = this.$refs.HmBulletinBoard;
      this.bulletinBoardList.forEach(v => {
        v.searchConditions = this.searchConditions;
      });
      refsList.map(v => {
        v.search();
      });
    },
    handleResize() {
      this.calcMainEleHeight();
    },
    calcMainEleHeight() {
      setTimeout(() => {
        const headerHeight = this.getBoundingClientRect(".navbar", "y");
        const tagHeight = this.getBoundingClientRect(
          ".tags-view-container",
          "y"
        );
        const stepsHeight = this.getBoundingClientRect(".step-wrapper", "y");
        const footerHeight = this.getBoundingClientRect(".el-footer", "height");
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          60;
        this.bulletinBoardList.forEach(v => {
          v.scrollHeight = this.scrollHeight;
        });
      }, 0);
    },
    getBoundingClientRect(el, type) {
      if (document.querySelector(el)) {
        const result = document.querySelector(el).getBoundingClientRect()[type];
        return result || 0;
      }
      return 0;
    }
  }
};
</script>

<style scoped lang="scss">
.bulletion-container {
  min-width: 480px;
  overflow-x: auto;
  overflow-y: hidden;
  .panel {
    min-width: 1168px;
    background: #fff;
    padding: 18px 30px;
    margin-bottom: 10px;
  }
}
</style>
